export const APPLICATION_PDF = 'application/pdf';
export const IMAGE_PNG = 'image/png';
export const IMAGE_JPEG = 'image/jpeg';
export const IMAGE_GIF = 'image/gif';
